// SD51 / SD56 / FR-AD7: the operator console's Notetaker tab. The bot's platform-wide switches and
// auto-leave rules are settings (SD58), not credentials, so they have their own tab rather than
// sitting among the write-only credential cards on Integrations.
import { Link } from "react-router-dom";
import OpsNotetakerCard from "./OpsNotetakerCard";

export default function OpsNotetakerPage() {
  return (
    <>
      <header className="page-head">
        <div>
          <h1>Notetaker</h1>
          <p>
            Which meeting platforms the notetaker bot may join and when it leaves, for every org. Changes apply on
            the next join, with no redeploy. The bot's Zoom, Teams and Meet credentials are on{" "}
            <Link to="/ops/integrations">Integrations</Link>; an org's own bot switch is on its page under{" "}
            <Link to="/ops/orgs">Orgs</Link>.
          </p>
        </div>
      </header>
      <OpsNotetakerCard />
    </>
  );
}
